var EventEmitter = require('eventemitter3');

/**
 * @class
 * @classdesc Класс, реализующий механизм менеджмента событий
 * @memberof module:events
 */
class EventDispatcher extends EventEmitter {

    /**
     * @constructor
     */
    constructor() {
        super();
    }

    destructor(){
        this.removeAllListeners();
    }

    emit(type, params) {

        if(!params) params = {};
        if(!params.type) params.type = type;
        if(!params.target) params.target = this;

        super.emit(type, params);
    }

    hasListeners(type) {
        return this.listeners(type).length > 0;
    }
}

export default EventDispatcher;